import '@shopify/polaris/build/esm/styles.css'
import './App.scss'
import { AppProvider, Frame } from '@shopify/polaris'
import { Provider as AppBridgeProvider, NavigationMenu } from '@shopify/app-bridge-react'
import useToken from './hooks/useToken'
import { Provider as SessionProvider } from './context/main'
import { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'
import RouterComponent from './Router'

function App() {
  const { error, token, host } = useToken()

  useEffect(() => {
    const loadFullStory = async () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(async () => {
          const { default: FullStoryScript } = await import('./lib/external/FullStoryScript')
          FullStoryScript()
        })
      } else {
        const { default: FullStoryScript } = await import('./lib/external/FullStoryScript')
        FullStoryScript()
      }
    }
    loadFullStory()
  }, [])

  if (error) return <div>Error: missing shop or host</div>
  if (!token || !host) return <div>Loading...</div>

  return (
    <div className="App">
      <SessionProvider token={token}>
        <AppProvider>
          <Router>
            <AppBridgeProvider
              config={{
                apiKey: process.env.REACT_APP_API_KEY,
                host,
                forceRedirect: !Boolean(process.env.REACT_APP_DEBUG_MODE),
              }}
            >
              <Provider store={store}>
                <Frame>
                  <NavigationMenu
                    navigationLinks={[
                      {
                        label: 'Dashboard',
                        destination: '/'
                      },
                      {
                        label: 'Billing',
                        destination: '/pricing'
                      },
                      {
                        label: 'Help',
                        destination: '/get-help'
                      },
                      {
                        label: 'Get support',
                        destination: '/get-support'
                      },
                      {
                        label: 'Suggestion Box',
                        destination: '/suggestion-box'
                      }
                    ]}
                  />
                  <RouterComponent />
                </Frame>
              </Provider>
            </AppBridgeProvider>
          </Router>
        </AppProvider>
      </SessionProvider>
    </div>
  )
}

export default App
